export class AllocationViewSupportSMSCountryCodesLoad {
  public static readonly type = '[AllocationViewSupportSMS] Country Codes Load';
}
export class AllocationViewSupportedSMSSet {
  public static readonly type = '[AllocationViewSupportSMS] Set support';
  constructor(public payload: boolean) {}
}

export class AllocationViewSupportSMSInitialState {
  public static readonly type = '[AllocationViewSupportSMS] Initial State';
}
